import { Box, Icon, ModalDialog, Text } from '@jfs/ui-new'
import { FC } from 'react'
import { testIds } from '../../utils/string'
import { styles } from './styles'

interface AlertProps {
  type?: string
  title?: string
  subTitle: string
  negativeLabel?: string
  positiveLabel?: string
  onCancelPress: () => void
  onOkPress: () => void
  visible?: boolean
}

const ConfirmAlert: FC<AlertProps> = ({
  title,
  subTitle,
  negativeLabel = 'No',
  positiveLabel = 'Yes',
  onCancelPress,
  onOkPress,
  visible = false,
}: AlertProps) => {
  return (
    <ModalDialog type="CenteredWrap" title={''} show={visible} onDismiss={onCancelPress}>
      <Box {...styles.alertOutercontainer} testID={'confirmDeleteId'}>
        <Box width="100%" alignItems="flex-end">
          <Box testID={testIds.dismissId} {...styles.approvecloseIconBox} onPress={onCancelPress}>
            <Icon id={'CLOSE'} size={24} color={'BLACK'} />
          </Box>
        </Box>
        <Box {...styles.approvetopBox}>
          <Box testID={testIds.titleSubtitleID} {...styles.approveTitlesBox}>
            {title && <Text {...styles.title}>{title}</Text>}
            <Text {...styles.subTitle}>{subTitle}</Text>
          </Box>
        </Box>
        <Box {...styles.buttonsBox}>
          <Box testID={testIds.cancelBtnID} {...styles.cancelBtn} onPress={onCancelPress}>
            <Text color="DARK_BLUE" type="body2" fontFamily="jioType-medium">
              {negativeLabel}
            </Text>
          </Box>
          <Box testID={testIds.okBtnID} {...styles.approveRejectBtn} onPress={onOkPress}>
            <Text color={'WHITE'} type="body2" fontFamily="jioType-medium">
              {positiveLabel}
            </Text>
          </Box>
        </Box>
      </Box>
    </ModalDialog>
  )
}

export { ConfirmAlert }
